import Api from './baseApi';

export default {
  getMpCompanies: (params = {}) => {
    const qp = [];
    if (params.tenantId !== null && params.tenantId !== undefined && params.tenantId !== '') qp.push(`tenantId=${encodeURIComponent(params.tenantId)}`);
    if (params.mpId !== null && params.mpId !== undefined && params.mpId !== '') qp.push(`mpId=${encodeURIComponent(params.mpId)}`);
    if (params.companyId !== null && params.companyId !== undefined && params.companyId !== '') qp.push(`companyId=${encodeURIComponent(params.companyId)}`);
    const qs = qp.length ? `?${qp.join('&')}` : '';
    return Api.get(`/api/mpcompanies${qs}`);
  },
  getMpCompany: (id) => Api.get(`/api/mpcompanies/${id}`),
  postMpCompany: (model) => Api.post('/api/mpcompanies', model),
  putMpCompany: (id, model) => Api.put(`/api/mpcompanies/${id}`, model),
  deleteMpCompany: (id) => Api.delete(`/api/mpcompanies/${id}`),
};

